import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../../api/apiClient";
import {
  createGatewayStart,
  createGatewayFailure,
  createGatewaySuccess,
  updateGatewaySuccess,
  updateGatewayFailure,
  updateGatewayStart,
  deleteGatewaySuccess,
  deleteGatewayFailure,
  deleteGatewayStart,
} from "../../../store/features/customer/gateway/gatewaySlice";
import { fetchInstrumentsStart } from "../../../store/features/customer/instruments/instrumentsSlice";

const URL = buildApiUrl("/api/v1/instruments/gateway/");

// CREATE
const createGatewayApi = async ({ data, accessToken }) => {
  try {
    const response = await axios.post(URL, data, {
      headers: getAuthHeaders(accessToken),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message };
  }
};

function* handleCreateGatewaySaga(action) {
  try {
    const data = yield call(createGatewayApi, action.payload);
    yield put(createGatewaySuccess(data));
  } catch (error) {
    yield put(createGatewayFailure(error));
  }
}

//UPDATE
const updateGatewayApi = async ({ data, gatewayId, accessToken }) => {
  try {
    const response = await axios.put(`${URL}${gatewayId}/`, data, {
      headers: getAuthHeaders(accessToken),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message };
  }
};

function* handleUpdateGatewaySaga(action) {
  try {
    const data = yield call(updateGatewayApi, action.payload);
    yield put(updateGatewaySuccess(data));
  } catch (error) {
    yield put(updateGatewayFailure(error));
  }
}

//DELETE
const deleteGatewayApi = async ({ gatewayId, accessToken }) => {
  try {
    const response = await axios.delete(`${URL}${gatewayId}/`, {
      headers: getAuthHeaders(accessToken),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message };
  }
};

function* handleDeleteSensorSaga(action) {
  try {
    const data = yield call(deleteGatewayApi, action.payload);
    yield put(deleteGatewaySuccess(data));
    yield put(
      fetchInstrumentsStart({ accessToken: action.payload.accessToken })
    );
  } catch (error) {
    yield put(deleteGatewayFailure(error));
  }
}

export default function* gatewaySaga() {
  yield takeLatest(createGatewayStart.type, handleCreateGatewaySaga);
  yield takeLatest(updateGatewayStart.type, handleUpdateGatewaySaga);
  yield takeLatest(deleteGatewayStart.type, handleDeleteSensorSaga);
}
